import _ from 'lodash';
import React from 'react';
import { Container, Row, Col } from 'reactstrap';

const keys = {
};

export function Keys( props ) {
  return (
    <Container fluid>
      {_.map( keys, ( desc, key ) => {
        return (
          <Row>
            <Col xs="3"><kbd>{key}</kbd></Col>
            <Col xs="9">{desc}</Col>
          </Row>
        );
      } )}
    </Container>
  );
}
